import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'test-emails'
const verb = 'get'

export default class OspreyTestEmails extends BaseAction {
    constructor(dataKey) {
        const id = 'd340204c-4baa-4b50-b5a5-dad013cf26cc'
        const path = `/${resource}/recent-addresses`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getEmails(contextOrn) {
        this.path = `/${resource}/recent-addresses?X-Context-Orn=${contextOrn}`

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/test-send/test-emails.js